import PropTypes from 'prop-types';
import React from 'react';
import { useUpdateEffect } from 'react-use';
import PropertyCard from 'components/PropertyCard';
import { useHover } from 'hooks/useHover';
import { Box } from '@qga/roo-ui/components';

const Result = ({ property, onHover, onClick }) => {
  const { id: propertyId, latitude: lat, longitude: lng } = property;
  const [isHovered, hoverEventHandlers] = useHover();

  useUpdateEffect(() => {
    const hoveredPropertyId = isHovered ? propertyId : null;

    onHover({
      id: hoveredPropertyId,
      lat,
      lng,
    });
  }, [isHovered]);

  return (
    <Box {...hoverEventHandlers} mb={6} mx={4} data-testid="results-list-results">
      <PropertyCard {...property} onClick={onClick} inline showCampaignMessage />
    </Box>
  );
};

Result.propTypes = {
  property: PropTypes.object.isRequired,
  onHover: PropTypes.func.isRequired,
  onClick: PropTypes.func,
};

Result.defaultProps = {
  onClick: undefined,
};

export default Result;
